import React from 'react';
import PropTypes from 'prop-types';
import { EuiComboBox } from '@elastic/eui';

export const ComboMultiple = (props) =>{
  
  let propiedades = {
    id: props.id,
    options:props.options || [],
    selectedOptions: props.options ? (Array.isArray(props.selectedOptions) ? props.selectedOptions : []) : [],
    onChange: props.onChange || (()=>{}),
    isInvalid: props.isInvalid || false,
    isDisabled: props.isDisabled || false,
    readOnly: props.readOnly || false,
    fullWidth: props.fullWidth !==undefined ? props.fullWidth : false,
    isLoading: props.options===undefined && !props.isDisabled,
    compressed: props.compressed !==undefined ? props.compressed : false,
    singleSelection: props.singleSelection !==undefined ?  props.singleSelection : true,
    renderOption: props.renderOption ? props.renderOption : undefined,
    onCreateOption: props.renderOption ? props.onCreateOption : undefined
  }
  
  return (
    <EuiComboBox {...propiedades}/>
  )
}
export default ComboMultiple